import { FC } from 'react'
import { ButtonsBlock } from '../../../Edit/components'
import { Modal, CenteredSpin } from '../../../ui'
import { Alert, Typography } from 'antd'
import style from './style.m.less'
import { buyPackage } from './config'
import {isExpired, signBody} from '../../../helpers'
import useRequest from '../../../hooks/useRequest'
import { useAppSelector } from '../../../../store/hooks'
import { useCurrentUser } from '../../../hooks/useCurrentUser'
import { moneyAmountFormatter } from '../../../helpers/moneyAmountFormatter'
import { useTranslation } from 'react-i18next'
import {EUserType} from "../../../../constants/approval";

interface IBuyPackageModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    fee: number
    type: number
    userBalance: number
}

const BuyPackageModal: FC<IBuyPackageModal> = ({
    isModalVisible,
    setIsModalVisible,
    fee,
    type,
    userBalance,
}) => {
    const { fetch } = useRequest(buyPackage)
    const { t } = useTranslation()

    const { isUserAdmin, isGOOwner } = useCurrentUser()
    const handleCancel = () => {
        setIsModalVisible(false)
    }

    const userInfo = useAppSelector((store) => store.user)
    const { data } = userInfo
    const isSignExpired = isGOOwner && isExpired(data?.certificate_data.token_expiration)
    // У пользователя должна быть МЧД
    const needAttorney = data?.user_type === EUserType.UrLico && isGOOwner && !data?.without_attorney
    // У пользователя должна быть МЧД, но её нет
    const isEmptyAttorney = needAttorney && !data?.machine_readable_attorney
    // У пользователя есть МЧД и у неё истёк срок
    const isAttorneyExpired = needAttorney
        && !!data?.machine_readable_attorney
        && isExpired(data?.machine_readable_attorney.validity_period, true)

    const handleConfirm = async () => {
        const body = { service_type_id: type }
        const { request_id, signature } = await signBody(body, data)
        fetch({
            body,
            config: {
                headers: {
                    Signature: signature,
                },
            },
            getParams: {
                request_id,
            },
            successMessage: {
                title: 'Успешно',
                description: 'Пакет услуг успешно приобретен',
            },
            onSuccess: () => handleCancel(),
            errorCodeMessage: true,
        })
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.mainWrapper}>
                <div className={style.contentWrapper}>
                    <div className={style.modalHeader}>
                        {'Купить пакет услуг по внесению записей'}
                    </div>
                    <Alert
                        message={
                            <>
                                <div>
                                    Тариф начинает действовать со следующего месяца после покупки.
                                </div>
                                <div>Срок действия пакета услуг 3 месяца.</div>
                                <div>
                                    Подключение следующего пакета услуг будет доступно за 14 дней до
                                    окончания текущего пакета услуг.
                                </div>
                            </>
                        }
                        className={style.infoAlert}
                        type="info"
                        showIcon
                    />
                    <Alert
                        className={style.modalAlert}
                        message={
                            <div className={style.modalAlertText}>
                                <div>
                                    За операцию взымается оплата в размере{' '}
                                    <Typography.Text strong>{`${fee} ₽`}</Typography.Text>
                                </div>
                                <div>
                                    Баланс платежного счета:{' '}
                                    {moneyAmountFormatter.format(userBalance)}
                                </div>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />
                    {isSignExpired && (
                        <Alert
                            className={style.signError}
                            message={'Истек срок действия ЭП'}
                            type="error"
                            showIcon
                        />
                    )}
                    {(isEmptyAttorney || isAttorneyExpired) && (
                        <Alert
                            className={style.signError}
                            message={isEmptyAttorney ? t('profile.attorneyIsMissing') : t('profile.attorneyIsExpired')}
                            type="error"
                            showIcon
                        />
                    )}
                    <div className={style.buttonsBlock}>
                        <ButtonsBlock
                            confirmAction={handleConfirm}
                            cancelAction={handleCancel}
                            confirmTitle={'Подписать и купить'}
                            confirmDisabled={isSignExpired || isEmptyAttorney || isAttorneyExpired}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default BuyPackageModal
